import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
const IssueCounter = ({ issuesCount, issuesDiff, showDiff = true }) => {
    const { t } = useTranslation();
    const formater = new Intl.NumberFormat(t('numberFormatLocale'));
    return _jsxs("span", { children: [formater.format(issuesCount), " ", t('commitIssues', { count: issuesCount }), showDiff && issuesDiff !== 0 ? (issuesDiff > 0 ? (_jsxs("small", { className: "text-danger", children: [' ', "(+", formater.format(issuesDiff), ")"] })) : (_jsxs("small", { className: "text-success", children: [' ', "(", formater.format(issuesDiff), ")"] }))) : ('')] });
};
export default IssueCounter;
